define('rebrush/components/cart/etracker',[
    'jquery',
    'lodash',
    'cartware/components/_base'
], function(
    $,
    _,
    Component
) {
    return Component.create({
        $init: function () {

            var self = this;

            if( typeof window._etrackerOnReady === 'undefined' ) {
                window._etrackerOnReady = [];
            }

            // insertToBasket Tracking
            $(document).on('cartware_cart/add', function(event, response) {

                if (response.etracker) {
                    var eventData = response.etracker;
                    var eTrackerEvent = eventData.event;
                    self.sendEtrackerEvent(eTrackerEvent, eventData);
                }
            });

            // removeFromBasket Tracking
            $(document).on('cartware_cart/remove', function(event, response) {

                if (response.etracker) {
                    var eventData = response.etracker;
                    var eTrackerEvent = eventData.event;
                    self.sendEtrackerEvent(eTrackerEvent, eventData);
                }
            });

            // updateCart Tracking
            $(document).on('cartware_cart/update', function(event, response) {

                if (response.etracker) {
                    var eventData = response.etracker;
                    var eTrackerEvent = eventData.event;
                    self.sendEtrackerEvent(eTrackerEvent, eventData);
                }
            });
        },
        sendEtrackerEvent: function(eTrackerEvent, eventData) {

            var etCommerceProduct = {
                id: eventData.id,
                name: eventData.name,
                price: eventData.price,
                currency: eventData.currency,
                category: eventData.category
            };

            var etCommerceQuantity = Number(eventData.qty);

            var etCommerceBasketId = eventData.basket;

            window._etrackerOnReady.push(function() {
                window.etCommerce.sendEvent(eTrackerEvent, etCommerceProduct, etCommerceQuantity, etCommerceBasketId);
            });
        }
    });
});
